<template>
    <template v-if="!isDataLoading">
        <div v-if="isLoading" class="quiz__loading">
            <div class="quiz__text">{{ $t('quiz.loading.text') }}</div>
            <div class="quiz__subtitle">{{ $t('quiz.loading.calculating-text') }}</div>
            <img src="@/assets/images/spinner.svg" :alt="$t('quiz.loading.calculating-text')">
        </div>

        <div v-else class="quiz__results">
            <h2 class="quiz__score">{{ score }}/{{ total }}</h2>
            <p class="quiz__desc">{{ $t('quiz.correct-answers-text') }}</p>
            <p class="quiz__text">{{ currentText }}</p>
            <img :src="require(`@/assets/images/` + currentImage)" :alt="currentText" class="quiz__img" />
            <div class="btn-wrapper">
                <button @click="tryAgain" class="btn btn--primary">{{ $t('button.try-again')}}</button>
            </div>
        </div>
    </template>
</template>

<script>
export default {
    name: 'QuizResult',
    props: ['score', 'total', 'isDataLoading'],
    emits: ['reset'],
    data() {
        return {
            isLoading: true,
            possibleResults: [
                {
                    text: this.$t('quiz.results.bad-result-text'),
                    image: 'quiz-result-bad.svg'
                },
                {
                    text: this.$t('quiz.results.okay-result-text'),
                    image: 'quiz-result-okay.svg'
                },
                {
                    text: this.$t('quiz.results.good-result-text'),
                    image: 'quiz-result-good.svg'
                },
                {
                    text: this.$t('quiz.results.great-result-text'),
                    image: 'quiz-result-great.svg'
                }
            ],
            currentText: null,
            currentImage: null
        }
    },
    methods: {
        calculateScore() {
            const score = Math.round((this.score / this.total) * 100);

            if (score <= 35) {
                this.currentText = this.possibleResults[0].text;
                this.currentImage = this.possibleResults[0].image;
            } else if (score > 35 && score <= 65) {
                this.currentText = this.possibleResults[1].text;
                this.currentImage = this.possibleResults[1].image;
            } else if (score > 65 && score <= 80) {
                this.currentText = this.possibleResults[2].text;
                this.currentImage = this.possibleResults[2].image;
            } else if (score > 80) {
                this.currentText = this.possibleResults[3].text;
                this.currentImage = this.possibleResults[3].image;
            } else {
                this.$router.push({name: 'quiz-start'});
            }
        },
        tryAgain() {
            this.$emit('reset');
        }
    },
    mounted() {
        this.calculateScore();

        setTimeout(() => {
            this.isLoading = false;
        }, 3000);
    }
}
</script>
